import { getSite } from '../../../provolution/jsCore/application/pageDataObject'
export function trackGoogleAnalyticsSessionId() {
  if (getSite() !== 'ei' && undefined !== ga) {
    ga(function(tracker) {
      if (undefined !== tracker && null !== tracker) {
        const id = tracker.get('clientId')
        if (undefined !== id && id !== null && id.length > 2) {
          window.experimentId = parseInt(id.substring(id.length - 2, id.length))
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/googleAnalyticaSessionTracker/googleAnalyticaSessionTracker.js